// import { Redirect } from "react-router-dom"
import { all, call, fork, put, takeEvery } from "redux-saga/effects"
import { getFlagshipListApi } from "../../Service/Api/FlagshipListApi";
import { getFlagship, getErrors } from "../Reducer/FlagshipListReducer";

// Watchers
function* flagshipListSaga() {
	yield takeEvery("flagshipList/getFlagshipList", fetchFlagship)
}

// Sagas
function* fetchFlagship(action) {

	try {
		const flagshipList = yield call(getFlagshipListApi, action.payload)

		if (flagshipList.request.status === 200) {
			yield put(getFlagship(flagshipList))
		} else {
			yield put(getErrors(true))
		}
	} catch (error) {
		yield put(getErrors(error))
	}
}

export default function* rootSaga() {
	yield all([fork(flagshipListSaga)])
}
